/**
 * Que lineas de convocatoria ve cada persona en los filtros.
 *
 * El alcance se decide por el documento de quien entro. No hay un permiso que
 * lo exprese: el catalogo de permisos habla de pantallas (Artistas, Beps,
 * Resultados de evaluacion), no de entidades, asi que mientras el backend no
 * guarde el alcance la regla vive aqui, en un solo lugar.
 *
 * Antes estaba repetida como cuatro <Select> encadenados por documento dentro
 * de cada pantalla. Quien tenia alcance total cumplia dos condiciones a la vez
 * y le aparecian dos filtros de linea, uno debajo del otro.
 */

export type AlcanceLineas = "todas" | "mcm" | "sm" | "general";

/** Las lineas de estas entidades se distinguen por como termina el nombre. */
export const MARCA_SM = "- SM";
export const MARCA_MCM = "- MCM";

const ALCANCE_POR_DOCUMENTO: { [documento: string]: AlcanceLineas } = {
  "1152462177": "todas",
  "1152210452": "mcm",
  "1128407398": "sm",
};

export const alcanceDeLineas = (documento?: any): AlcanceLineas =>
  ALCANCE_POR_DOCUMENTO[String(documento ?? "")] ?? "general";

const marcada = (nombre: any, marca: string) =>
  String(nombre ?? "").includes(marca);

/**
 * Las lineas que puede ver esa persona, en el orden en que se muestran
 * (de la mas reciente a la mas antigua).
 */
export const lineasVisibles = (lineas: any[], documento?: any): any[] => {
  const alcance = alcanceDeLineas(documento);

  const visibles = (lineas ?? []).filter(({ nombre }: any) => {
    if (alcance === "todas") return true;
    if (alcance === "mcm") return marcada(nombre, MARCA_MCM);
    if (alcance === "sm") return marcada(nombre, MARCA_SM);
    return !marcada(nombre, MARCA_SM) && !marcada(nombre, MARCA_MCM);
  });

  // filter ya devolvio un arreglo nuevo, asi que invertirlo no toca el original.
  return visibles.reverse();
};
